module.exports = __webpack_public_path__ + "static/media/svg-blur.6bccb16d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/slides/05-why-gatsby/video/svg-blur.mp4
// module id = 952
// module chunks = 0